import { QuestsResponse } from "../../types/quests";

export const getQuestsModel = (
  response: QuestsResponse
): QuestsResponse => response;
